import { useExperiment } from '@hungryroot/experiments';
import { Goals } from '../defs';

function shuffleArray<T>(a: T[]): T[] {
  let j, x, i: number;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

const variantGoalsAnswers = [
  {
    label: 'Save time',
    value: Goals.SaveTime,
  },
  {
    label: 'Improve health',
    value: Goals.ImproveHealth,
  },
  {
    label: 'Lose weight',
    value: Goals.LoseWeight,
  },
  {
    label: 'Grocery shop less',
    value: Goals.GroceryShopLess,
  },
  {
    label: 'Waste less food',
    value: Goals.WasteLessFood,
  },
  {
    label: 'Simplify cooking',
    value: Goals.SimplifyCooking,
  },
  {
    label: 'Save money',
    value: Goals.SaveMoney,
  },
  {
    label: 'Lower stress',
    value: Goals.LowerStress,
  },
];
const shuffledVariantOptions = shuffleArray(variantGoalsAnswers);

// If the user has persisted goals from a previous session when a different set of possible goals was rendered, remove any goals that are no longer valid. When the experiment code is removed. This logic will need to be updated to handle users who might have persisted data from the losing variant.
const getValidPersistedGoals = (
  persistedGoals: number[] | null,
  validGoals: Set<Goals>
): Goals[] => persistedGoals?.filter((goal) => validGoals.has(goal)) ?? [];

export function useGoalsAnswersExperimentApi(
  shuffledDefaultOptions: {
    label: string;
    value: Goals;
  }[],
  persistedGoals: Goals[] | null
) {
  const variant = useExperiment(152);

  if (variant === undefined) {
    return;
  }

  if (variant < 1) {
    return {
      shuffledGoalsOptions: shuffledDefaultOptions,
      goals: getValidPersistedGoals(
        persistedGoals,
        new Set(shuffledDefaultOptions.map((option) => option.value))
      ),
    };
  }

  return {
    shuffledGoalsOptions: shuffledVariantOptions,
    goals: getValidPersistedGoals(
      persistedGoals,
      new Set(shuffledVariantOptions.map((option) => option.value))
    ),
  };
}
